import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./PaymentSuccessPage.scss";

const PaymentSuccessPage = () => {
  const { restaurant, id, table } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Optional: auto redirect to home after 10 sec
    const timer = setTimeout(() => {
      navigate(`/${restaurant}/${id}/${table}/menu`);
    }, 90000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <div className="success-icon">✓</div>

        <h1>Payment Successful</h1>

        <p className="sub-text">
          Payment Received! We hope you enjoyed your meal. See you again soon!
        </p>

        <div className="divider" />

        {/* <div className="info-row">
          <span>Payment Status</span>
          <span className="success-text">Verified</span>
        </div> */}

        <div className="info-row">
          <span>Enjoyed your meal 🍽️</span>
          <span>Thank you for dining with us ❤️</span>
        </div>

        <p className="footer-note">
          You may safely close this page or you will be redirected shortly.
        </p>

        <button
          className="home-btn"
          onClick={() => navigate(`/${restaurant}/${id}/${table}/menu`)}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
